export const emailConstants = {

    SUBMIT_EMAIL: 'SUBMIT_ONBOARDING_STEP_REQUEST',
    SUBMIT_EMAIL_FAILURE: 'SUBMIT_ONBOARDING_STEP_FAILURE',
    SUBMIT_EMAIL_SUCCESS: 'SUBMIT_ONBOARDING_STEP_SUCCESS',

    RESET_EMAIL_STATE: 'RESET_EMAIL_STATE'
};